// Feedback Service - Handles AI feedback API calls
import api from './api';

export interface AIFeedbackEntry {
  id: number;
  experimentNumber: number;
  experimentName: string;
  feedbackText: string;
  feedbackType: string;
  strengths: string[];
  areasForImprovement: string[];
  overallRating: string; // 'excellent' | 'good' | 'satisfactory' | 'needs_improvement'
  aiModelUsed: string | null;
  createdAt: string;
}

export const feedbackService = {
  async generateFeedback(courseId: string, experimentNumber: number): Promise<AIFeedbackEntry | null> {
    const res = await api.post<{ success: boolean; feedback: AIFeedbackEntry }>(
      `/feedback/${courseId}/${experimentNumber}/generate`
    );
    return res.success && res.data ? res.data.feedback : null;
  },

  async getExperimentFeedback(courseId: string, experimentNumber: number): Promise<AIFeedbackEntry | null> {
    const res = await api.get<{ success: boolean; feedback: AIFeedbackEntry }>(
      `/feedback/${courseId}/${experimentNumber}`
    );
    return res.success && res.data ? res.data.feedback : null;
  },

  async getCourseFeedback(courseId: string): Promise<AIFeedbackEntry[]> {
    const res = await api.get<{ success: boolean; feedback: AIFeedbackEntry[] }>(
      `/feedback/${courseId}`
    );
    return res.success && res.data ? res.data.feedback : [];
  },
};

export default feedbackService;
